import { type ClassValue, clsx } from 'clsx';

export const cn = (...values: ClassValue[]): string => clsx(values);
